import { PaymentMethodResult } from '@mews-commander/data-access';
import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PaymentMethodRecord } from './components/tables/PaymentMethods/types';

export const useGetPaymentMethodsRecords = () => {
    const localizeText = useLocalizeText();

    return ({ paymentCards, sepas }: PaymentMethodResult) => {
        const cardsPaymentMethods =
            paymentCards?.map((paymentCard) => ({
                ...paymentCard,
                title: `${paymentCard.type} ${paymentCard.lastDigits}`,
            })) ?? [];
        const sepaPaymentMethods =
            sepas?.map((sepa) => ({
                ...sepa,
                title: `${localizeText({ textKey: TextKey.Sepa })} ${sepa.lastDigits}`,
            })) ?? [];

        return [...cardsPaymentMethods, ...sepaPaymentMethods] as PaymentMethodRecord[];
    };
};
